import { useNavigate } from "react-router-dom";
import { SubserviceComponent } from "../../../../types/alhadeed";

interface Props {
  data?: SubserviceComponent;
}
const ServiceInDubai: React.FC<Props> = ({ data }) => {
  const navigate = useNavigate();

  return (
    <>
      <section className="bg-2 py-5 py-md-5">
        <div className="container">
          <div className="row">
            <div className="font-35 ff-bold">
              <h2 className="hd-style-2 font-35 ff-bold"
                dangerouslySetInnerHTML={{
                  __html: data?.heading ?? "",
                }}
              ></h2>
            </div>

            {data?.data?.map((item) => (
              <>
                <div className="row" key={`new-service-${item.id}`}>
                  {item.id % 2 !== 0 && (
                    <div className="col-md-5 mb-5 d-none d-md-block" >
                      <img
                        src={item?.src}
                        alt=""
                        height={300}
                        className="d-md-block d-none mx-auto"
                      />
                    </div>
                  )}
                  <div className="col-md-6 my-md-auto my-3">
                    <div className="p-3 bg-white shadow-sm rounded">
                      <h3 className="mb-3 font-18 ff-bold text-black">{item?.title}</h3>
                      {item?.description?.map((desc) => (
                        <p className="font-12 text-black">{desc}</p>
                      ))}
                      <button
                        className="btn btn-primary font-14 ff-semibold margin-minus bt--cart h-75"
                        onClick={() => navigate(`/${item?.url}`)}
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                  {item.id % 2 === 0 && (
                    <div className="col-md-5 mb-5 d-none d-md-block">
                      <img
                        src={item?.src}
                        alt=""
                        height={300}
                        className="d-md-block mx-auto d-none"
                      />
                    </div>
                  )}
                </div>
              </>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceInDubai;
